// This is a static version of the Post component. It will be used to generate the PDF.
// Do not use for any other reason than for post 

import React, { useState, useEffect } from 'react'
import { setSender, setReceiver, setOrg, findOwner, fillProjectsData, fillProjectsDataContent } from '../Helpers/Functions/TemplateVariables'
import { detectBrowser } from '../Helpers/Functions/detectBrowser'

const browserInfo = detectBrowser()

export default function Post({post, users, current_user, team, pdfPages}) {
    const [browserIsSupported, setBrowserIsSupported] = useState(browserInfo.name === 'Safari' || browserInfo.name === 'Firefox')
    const manager = (window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager')

    useEffect(() => {
        if (document.readyState === 'complete') {
            Alert.show('notice', 'Printing will start in 7 seconds')
            setTimeout(() => window.print(), 8000)
        } else {
            Alert.show('notice', 'Printing will start in 7 seconds')
            setTimeout(() => window.print(), 8000)
        }
    }, [])

    useEffect(() => {
        window.onafterprint = function() {
            window.close()
        }
    })

    

    const showApprovalMessage = () => {
        if (!team.using_approvals) {
            return false
        }

        if (manager) {
            return true
        }

        if (current_user.id === post.user_id) {
            return true
        }

        if ((current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') && post.project && post.project.name) {
            return true
        }

        if (current_user.user_type == 'sponsorship_manager') {
            return true
        }

        return false
    }

    const orderMediaAssets = () => {
        let orderedAssets = []
        let mediaAssets = post.ordered_uploads

        if (mediaAssets.length > 0) {
            mediaAssets.forEach((asset) => {
                if (asset.file_type === 'image') {
                    orderedAssets.push(asset)
                }
            })

            mediaAssets.forEach((asset) => {
                if (asset.file_type === 'video') {
                    orderedAssets.push(asset)
                }
            })

            mediaAssets.forEach((asset) => {
                if (asset.file_type === 'pdf') {
                    orderedAssets.push(asset)
                }
            })

            mediaAssets.forEach((asset) => {
                if (asset.file_type === 'doc') {
                    orderedAssets.push(asset)
                }
            })
        }

        return orderedAssets
    }


    let postHolder = post
    let title = postHolder.title
    postHolder.safe_content = setOrg(post, team)
    postHolder.title = postHolder.title.replace(/{{organization.name}}/g, team.name)

    if (post.project_id == null) {
        let postOwner = post.user.user_info
        setSender(postHolder, postOwner)
    
        // if post owner is a donor and viewer is a beneficiary
        if (current_user.user_type == 'beneficiary' && postOwner.user_type == 'donor') {
          setReceiver(postHolder, current_user)
        } else if (current_user.user_type == 'donor' && postOwner.user_type == 'beneficiary') {
          setReceiver(postHolder, current_user)
        } else if (postOwner.user_type == 'manager' && current_user.user_type !== 'manager'){
          setReceiver(postHolder, current_user)
        } else if (postOwner.user_type == 'assistant_manager' && current_user.user_type !== 'assistant_manager'){
          setReceiver(postHolder, current_user)
        } else if (postOwner.user_type == 'project_manager' && current_user.user_type !== 'project_manager'){
          setReceiver(postHolder, current_user)
        } else if (postOwner.user_type == 'project_coordinator' && current_user.user_type !== 'project_coordinator'){
          setReceiver(postHolder, current_user)
        } else if (postOwner.user_type == 'sponsorship_manager' && current_user.user_type !== 'sponsorship_manager'){
          setReceiver(postHolder, current_user)
        }
    }

    if (post.user_id == null) {
        fillProjectsData(postHolder)
        postHolder.safe_content = fillProjectsDataContent(postHolder)
        if (current_user.user_type == 'beneficiary' || current_user.user_type == 'donor') {
          setReceiver(postHolder, current_user)
        }
    }
    
    let content = postHolder.safe_content;
    post.title = postHolder.title;
    content = <div dangerouslySetInnerHTML={{__html: content }} />


  return (
    <div>
        <div className="card card--post">
            <div className="card-header">
                <div className="card-title d-flex align-items-center justify-content-between">
                    <div>
                        {post.user_id !== null &&
                            <div className="card--name-title">
                                <a href={post.user_profile_url}><strong>{post.user.visible_name}</strong></a> · <a href={post.url}>{post.title}</a>
                            </div>
                        }

                        {post.user_id == null &&
                            <div className="card--name-title">
                                <a href={post.user_profile_url}><strong>{post.project.name}</strong></a> · <a href={post.url}>{post.title}</a>
                            </div>
                        }
                        <div className="card--post-time-ago">
                            <span className="mr-1">
                                {post.created_at_in_words}
                            </span>

                            {post.audience_members && post.audience_members.length > 0 && (
                                <span>
                                    <span className="ml-1 mr-2">·</span>
                                    <i className="fa-user-lock far" title='Audience'></i> {post.audience_names}
                                    {post.ordered_uploads.length > 0 && (<span className="ml-2 mr-1">·</span>)}
                                </span>
                            )}

                            {post.ordered_uploads.length > 0 && (
                                <span className="badge badge-sm badge-primary badge-pill ml-1">
                                    {post.ordered_uploads.length} Uploads
                                </span>
                            )}

                            {showApprovalMessage() && (
                                <React.Fragment>
                                    {!post.approved_at && (<div className="post--approval text-danger">
                                    <i className="fa fa-exclamation fa-exclamation-circle"></i> Waiting on approval and can continue to be edited
                                    </div>)}
                                    {post.approved_at && (<div className="post--approval text-success">
                                    <i className="fa fa-check fa-check-circle"></i> Post approved and cannot be edited anymore
                                    </div>)}
                                </React.Fragment>
                            )}

                            {post.show_in_pages && post.project_id && manager &&
                                <div><i class="far fa-eye text-blue"></i> Will show in associated public pages</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div>
                    {content}
                </div>

                {post.ordered_uploads && post.ordered_uploads.length > 0 && 
                    <section className='row mt-2 print-image-upload-block'>
                        {orderMediaAssets().map((file, index) => (
                            <div key={index} className='col-md-6 print-col-md-6'>
                                <div className='file-thumbnail-container'>
                                    {file.file_type == 'image' && 
                                        <a href={file.variant_large || file.cdn_url} className='image-link'>
                                            <img src={file.variant_large || file.cdn_url} className='img-fluid rounded' />
                                        </a>
                                    }

                                    {file.file_type == "pdf" &&
                                        <a href={file.src} target="_blank">
                                            <div className="document-block">
                                                <div className="w-100">
                                                    <i className="fa fa-file-pdf"></i>
                                                    <div>
                                                        {file.filename}
                                                    </div>  
                                                </div>
                                            </div>
                                        </a>
                                    }

                                    {file.file_type == "doc" &&
                                        <a href={file.src} target="_blank">
                                            <div className="document-block">
                                                <div className="w-100">
                                                    <i className="fa fa-file-alt"></i>
                                                    <div>
                                                    {file.filename}
                                                    </div>  
                                                </div>
                                            </div>
                                        </a>
                                    }

                                    {file.file_type == "video" &&
                                        <div className="video-upload-block">
                                            <a href={`#video-modal-${file.id}`} className="video-modal">
                                                <div className="document-block">
                                                    <div className="w-100">
                                                        <video width="100%" controls>
                                                            <source src={file.src} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                     </div>
                                                </div>
                                            </a>
                                            <div id={`video-modal-${file.id}`} className="mfp-hide jumbotron d-flex align-content-center justify-content-center">
                                                <video controls style={{maxWidth: '90%', maxHeight: '70vh'}}>
                                                    <source src={file.src} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        ))}
                    </section>
                }

                {post.user_id !== null &&
                    <div className="w-100 text-right">
                    <a href={post.url} className="card-link text-right">
                        { post.comments.count ? post.comments.count : 0 } comments
                    </a>
                    </div>
                }
            </div>
        </div>

        {pdfPages && pdfPages.length > 0 && browserIsSupported && pdfPages.map((pdfPage, index) => (
            <div className="pdf-viewer-printer" key={index}>
                <iframe src={`data:application/pdf;base64,${pdfPage}#toolbar=0`} type="application/pdf"></iframe>
            </div>
        ))}
    </div>
  )
}
